import { rest } from 'msw'
export default [
  /**
   * ????
   */
  rest.post('/api/v2/unsubscribe', (req, res, ctx) => {
    // Persist user's authentication in the session
    return res(
      ctx.status(200),
      ctx.json({
        error: {
          errorCode: 10,
          errorMessage: 'ユーザ登録エラー',
          errorMessageDetail: '既に登録済みのメールアドレスです',
        },
        status: 1,
        responseTime: 915148799,
      })
    )
  }),
  /**
   * ???
   */
  rest.get('/api/v2/get_content_point', (req, res, ctx) => {
    // Persist user's authentication in the session
    return res(
      ctx.status(200),
      ctx.json({
        error: {
          errorCode: 0,
          errorMessage: '',
          errorMessageDetail: '',
        },
        data: {
          status: 1,
          responseTime: '1562309754',
        },
      })
    )
  }),
  /**
   * ?????
   */
  rest.post('/api/v2/get_tokuten_list', (req, res, ctx) => {
    // Persist user's authentication in the session
    return res(
      ctx.status(200),
      ctx.json({
        error: {
          errorCode: 0,
          errorMessage: '',
          errorMessageDetail: '',
        },
        data: {
          items: [
            {
              id: 1,
              title: '秋のオールグリコフェア',
              point: 1000,
              mainImage:
                'https://static.retailstudio.jp/assets/features/268/thumbnail_65e1a5c282b57f8dd70039fcc6dd80af.jpg',
              referenceType: 'link',
              referenceLink: '/content',
            },
            {
              id: 2,
              title: '秋のオールグリコフェア',
              point: 5,
              mainImage:
                'https://static.retailstudio.jp/assets/features/268/thumbnail_65e1a5c282b57f8dd70039fcc6dd80af.jpg',
              referenceType: 'link',
              referenceLink: '/content',
            },
            {
              id: 3,
              title: '秋のオールグリコフェア',
              point: 50,
              mainImage:
                'https://static.retailstudio.jp/assets/features/268/thumbnail_65e1a5c282b57f8dd70039fcc6dd80af.jpg',
              referenceType: 'link',
              referenceLink: '/content',
            },
            {
              id: 4,
              title: '秋のオールグリコフェア',
              point: 150,
              mainImage:
                'https://static.retailstudio.jp/assets/features/268/thumbnail_65e1a5c282b57f8dd70039fcc6dd80af.jpg',
              referenceType: 'link',
              referenceLink: '/content',
            },
            {
              id: 5,
              title: '秋のオールグリコフェア',
              point: 5,
              mainImage:
                'https://static.retailstudio.jp/assets/features/268/thumbnail_65e1a5c282b57f8dd70039fcc6dd80af.jpg',
              referenceType: 'link',
              referenceLink: '/content',
            },
            {
              id: 6,
              title: '秋のオールグリコフェア',
              point: 150,
              mainImage:
                'https://static.retailstudio.jp/assets/features/268/thumbnail_65e1a5c282b57f8dd70039fcc6dd80af.jpg',
              referenceType: 'link',
              referenceLink: '/content',
            },
          ],
          count: 3,
          responseTime: 1600302088,
        },
      })
    )
  }),
  /**
   * ????
   */
  rest.get('/api/v2/get_review_list', (req, res, ctx) => {
    // Persist user's authentication in the session
    return res(
      ctx.status(200),
      ctx.json({
        error: {
          errorCode: 0,
          errorMessage: '',
          errorMessageDetail: '',
        },
        data: {
          reviews: [
            {
              chainId: 1,
              chainName: '大崎スーパー',
              chainLogo: 'https://content.xxxxxx/xxxx/0001.jpg',
              date: '1580396400',
              type: 'アンケート',
              title: 'そのまま食べれるトッピング　スーパー大麦',
              answers: [
                {
                  seq: '1',
                  question: 'この商品を購入したことがありますか',
                  type: 'yesno',
                  answer: '1',
                  freeText: '',
                },
                {
                  seq: '2',
                  question: 'この商品を購入したことがありますか',
                  type: 'radio',
                  answer: 'ある',
                  freeText: '',
                },
              ],
            },
            {
              chainId: 1,
              chainName: '大崎スーパー',
              chainLogo: 'https://content.xxxxxx/xxxx/0001.jpg',
              date: '1562309754',
              type: 'お買い物履歴',
              title: '桜新町店(2019/2/11 10:15来店)でのお買い物について',
              answers: [
                {
                  seq: '1',
                  question: '評価',
                  type: 'star',
                  answer: '5',
                  freeText: '',
                },
                {
                  seq: '2',
                  question: 'コメント',
                  type: 'freeText',
                  answer:
                    'レジ担当の方がいつも担当してくれるのですが、丁寧な対応を。。。',
                  freeText: '',
                },
              ],
            },
            {
              chainId: 1,
              chainName: '大崎スーパー',
              chainLogo: 'https://content.xxxxxx/xxxx/0001.jpg',
              date: '1563309754',
              type: 'お買い物履歴',
              title: '桜新町店(2019/2/11 10:15来店)でのお買い物について',
              answers: [
                {
                  seq: '1',
                  question: '評価',
                  type: 'star',
                  answer: '5',
                  freeText: '',
                },
                {
                  seq: '2',
                  question: 'コメント',
                  type: 'freeText',
                  answer:
                    'レジ担当の方がいつも担当してくれるのですが、丁寧な対応を。。。',
                  freeText: '',
                },
              ],
            },
          ],
          count: '10',
          responseTime: '915148799',
        },
      })
    )
  }),
  /**
   * ?????
   */
  rest.get('/api/v2/yoyaku_get_item_list', (req, res, ctx) => {
    // Persist user's authentication in the session
    return res(
      ctx.status(200),
      ctx.json({
        error: {
          errorCode: 0,
          errorMessage: '',
          errorMessageDetail: '',
        },
        data: [
          {
            id: 1,
            name:
              'シャンテ Y.A. マスカット・ベーリーA イグレック・カレ・キュベK',
            brand_name: 'ダイヤモンド酒造',
            content:
              'シモン・ビーズなどの著名生産者の元でワイン醸造を学んだ3代目の雨宮吉男氏が、食と相性のいいナチュラルでチャーミングなワインを生み出しています。こちらは高地で収穫されたマスカット・ベーリーAを、24ヵ月間樽熟成させたワイン。マスカット・ベーリーAの特徴的な香りを綺麗に樽香が包みます。「ブルゴーニュ帰りの男」による樽使いの妙をご堪能下さい。',
            amount: 3000,
          },
          {
            id: 2,
            name: 'ピノ・ノワール',
            brand_name: 'ヴィラデストワイナリー',
            content:
              'こちらは日本有数の少雨と南向き斜面の豊富な日照、そして標高の高さによる冷涼さという理想的な環境で育まれたブドウで仕立てられる1本。ワイン専門誌や一般誌でも多く取り上げられ、「高原の冷涼な気候を映し出すエレガントな味わい」、「ピノ・ノワールのニュアンスをはっきりと感じる注目の赤」など、高い評価を得ています。',
            amount: 4759,
          },
          {
            id: 3,
            name: '伊豆 プティ・ヴェルド',
            brand_name: '中伊豆ワイナリー',
            content:
              'こちらは、伊豆の温暖な気候のもと、中伊豆ワイナリーの農場で栽培した黒ブドウ品種「プティ・ヴェルド」を使用して造られた1本。ベリーを思わせる赤黒く熟した果実の香りに樽由来の香りが溶け込んでおり、口に含むとしっかりとした渋味にふくよかな果実の風味と、ほどよい酸味が感じられます。日本ワインのポテンシャルを感じさせる、見事な仕上がりです。',
            amount: 4630,
          },
        ],
      })
    )
  }),
  /**
   * ?????
   */
  rest.post('/api/v2/yoyaku_reserve', (req, res, ctx) => {
    // Persist user's authentication in the session
    return res(
      ctx.status(200),
      ctx.json({
        error: {
          errorCode: 0,
          errorMessage: '',
          errorMessageDetail: '',
        },
        data: {},
      })
    )
  }),
]
